import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home'
import Callback from '@/components/Callback'
import Contact from '@/components/Contact'
import Confirmation from '@/components/Confirmation'
import FlightInfo from '@/components/FlightInfo'
import Reservations from '@/components/Reservations'
import Payment from '@/components/Payment'
import AccountCodes from '@/components/AccountCodes'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/home',
      name: 'Home',
      component: Home
    },
    {
      path: '/contact',
      name: 'Contact',
      component: Contact
    },
    {
      path: '/confirmation',
      name: 'Confirmation',
      component: Confirmation
    },
    {
      path: '/reservations',
      name: 'Reservations',
      component: Reservations
    },
    {
      path: '/callback',
      name: 'Callback',
      component: Callback
    },
    {
      path: '/flight_info',
      name: 'FlightInfo',
      component: FlightInfo
    },
    {
      path: '/payment',
      name: 'Payment',
      component: Payment
    },
    {
      path: '/accountCodes',
      name: 'AccountCodes',
      component: AccountCodes
    },
    {
      path: '*',
      redirect: '/home'
    }
  ]
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js